import { KeyboardEvent } from 'react';
import { FormSectionElements, FormSections, FormSubSections, ProgramContainer } from '../entities/formTemplateDataType';
import { getRootComponent } from './ElementUtils';
import { fi } from 'date-fns/locale';

const holderRegex = /{{(.*?)}}/g;

export type Replacements = {
    [key: string]: any;
}

export const hasPlaceholdersInHtml = (content: string): boolean => {
    return holderRegex.test(content);
}

export const replaceHolders = (content: string, replacements?: Replacements): string => {
    let replacement = content;
    let holders = replacement.match(holderRegex);
    holders?.forEach(holder => {
        const holderName = holder.replace(holderRegex, '$1');
        const value = replacements.filter(item => Object.keys(item)[0] === holderName)
        if (value?.length) {
            replacement = replacement.replace(holder, value[0][holderName]);
        }
    });
    return replacement;
}

export const getPlaceHolderNames = (content: string): string[] => {
    const names = content?.match(holderRegex)?.map(holder => {
        return holder.replace(holderRegex, '$1');
    });
    return names ?? [];
}

export const replaceHoldersInRichText = (appId: string, content: string, field: FormSectionElements, lang='en'): string => {
    switch(appId) {
        case 'CPA-Quiz-Questions':
            return replaceQuizePlaceholders(content, field);
        default: return content;
    }
}

const replaceQuizePlaceholders = (content: string, field: FormSectionElements, lang='en'): string => { 
    let replacement = content;
    if (hasPlaceholdersInHtml(content)) {
        let section = getRootComponent(field);
        const quizData = getQuizHolderData(section, lang);
        if (Object.keys(quizData).length) {
            const holders = [{n: quizData.corrected}, {total: quizData.total}];
            replacement = replaceHolders(content, holders);
            console.log(replacement);
        }
    }
    return replacement;
}

export const getQuizHolderData = (programContainer: ProgramContainer, lang='en') => {
    const cols = getQuizTableColumns();
    const quizData = programContainer.ListOfFormSections.reduce((quizSum, sec) => {
        sec.ListOfFormSubSections.forEach(subSect => {
            const data = subSect.ListOfFormSectionElements.filter(element => element.Datatype === 'RadioButton')
                .reduce((sum, element) => {
                    const row = getQuizSummaryRowData(element, null, lang);
                    sum[cols[0]] = sum[cols[0]] || row[cols[0]];
                    sum[cols[1]] = sum[cols[1]] ? sum[cols[1]] + ', ' + row[cols[1]] : row[cols[1]];
                    sum[cols[2]] = sum[cols[2]] ? sum[cols[2]] + ', ' + row[cols[2]] : row[cols[2]];
                    return sum;
                }, {});

            if (Object.keys(data).length) {
                quizSum.total++;
                if (!data[cols[2]] || data[cols[1]]===data[cols[2]]) {
                    quizSum.corrected++;
                }
            }
        });
        return quizSum;
    },{total: 0, corrected: 0});
    return quizData;
}

export const getQuizTableColumns = (tableElement?: FormSubSections) => {
    return tableElement?.ListOfFormSectionElements?.map(
        col => (col.LoadBindBase ? col.LoadBindBase + '.' : '') + col.LoadBindName
    ) || ['Quiz No.', 'Your answer', 'Correct answer'];
}

export const getQuizSummaryRowData = (element: FormSectionElements, tableElement?: FormSubSections, lang='en') => {
    const cols = getQuizTableColumns(tableElement);
    const row = {};
    row[cols[0]] = lang === 'en' ? element.ENUTitle : element.FRATitle;
    row[cols[1]] = getQuizAnswer(element, lang);
    row[cols[2]] = getQuizExpectedValues(element,lang);
    return row;
}

export const getQuizAnswer = (element: FormSectionElements, lang='en') => {
    let val = '';
    if (element.Value) {
        const value = element.ListOfLOVValues?.filter(val => val.code === element.Value);
        if (value?.length) {
            val = lang === 'en' ? value[0].description : value[0].FRADescription ?? '';
        }
    }
    return val;
}

export const getQuizExpectedValues = (element: FormSectionElements, lang='en') => {
    let val = ''
    if (element.ListOfExpectedValues?.length) {
        val = element.ListOfLOVValues?.filter(val => element.ListOfExpectedValues.includes(val.code))
            .map(val => (lang === 'en' ? val.description : val.FRADescription ?? ''))
            .filter(val => !!val)
            .join(', ') ?? '';
    }
    return val;
}

export const isInputKeyPrintable = (e: KeyboardEvent<HTMLInputElement>): boolean => {
    return String.fromCharCode(e.keyCode).match(/(\w|\s)/g) != null;
}

export const getSubmitButtonFromCurrentSection = (field: FormSectionElements): FormSectionElements => {
    return field.parent.ListOfFormSectionElements.find(ele => ele.Datatype === 'RecaptchaButton' || ele.Datatype === 'Button');
}

export const triggerButtonSubmit = (submitBtn: FormSectionElements) => {
    const key = `button_${submitBtn.parent.Sequence}_${submitBtn.Id}`
    const htmlBtn = document.querySelector(`#${key}`);
    if (htmlBtn ) {
        (htmlBtn as HTMLButtonElement).click();
    }
}

export const submitForm = (field: FormSectionElements) => {
    const submitBtn = getSubmitButtonFromCurrentSection(field);
    if (submitBtn) {
        triggerButtonSubmit(submitBtn);
    }
}
